import { ActionTree, Module, MutationTree } from "vuex";
import { UserState, RootState } from "../type";
import { GetterTree } from "vuex";

// State
const state: UserState = {
    userInfo: {},
}


// Getters
const getters: GetterTree<UserState, RootState> = {
    
    // รับToken
    token: state => state.userInfo?.token || null,
}


// Mutations
const mutations: MutationTree<UserState> = {
    // ตั้งค่าข้อมูลผู้ใช้
    setUserInfo: (state, payload): void => {
        state.userInfo = payload;
    },

    // ล้างข้อมูลผู้ใช้
    clearUserInfo: (state): void => {
        state.userInfo = {};
    }
}


// Actions
const actions: ActionTree<UserState, RootState> = {


}


const user: Module<UserState, RootState> = {
    state,
    mutations,
    actions,
    getters
}

export default user
